import { FAQCategory, FAQItem } from '../../../types/FAQTypes'

export type GamerFAQItem = FAQItem

/**
 * Gamer FAQ items
 * This data is auto-generated from Google Sheets
 *
 * Each item contains translation keys that should be used with t('key')
 * The translation keys are automatically updated by running:
 * yarn import-faq
 */
export const gamerFaqItems = [
  {
    id: '1',
    questionKey: 'faq.gamer.question1',
    descriptionKey: 'faq.gamer.answer1',
    categories: [FAQCategory.GETTING_STARTED]
  },
  {
    id: '2',
    questionKey: 'faq.gamer.question2',
    descriptionKey: 'faq.gamer.answer2',
    categories: [FAQCategory.GETTING_STARTED]
  },
  {
    id: '3',
    questionKey: 'faq.gamer.question3',
    descriptionKey: 'faq.gamer.answer3',
    categories: [FAQCategory.GETTING_STARTED]
  },
  {
    id: '4',
    questionKey: 'faq.gamer.question4',
    descriptionKey: 'faq.gamer.answer4',
    categories: [FAQCategory.GETTING_STARTED]
  },
  {
    id: '5',
    questionKey: 'faq.gamer.question5',
    descriptionKey: 'faq.gamer.answer5',
    categories: [FAQCategory.GETTING_STARTED]
  },
  {
    id: '6',
    questionKey: 'faq.gamer.question6',
    descriptionKey: 'faq.gamer.answer6',
    categories: [FAQCategory.GETTING_STARTED]
  },
  {
    id: '7',
    questionKey: 'faq.gamer.question7',
    descriptionKey: 'faq.gamer.answer7',
    categories: [FAQCategory.ONBOARDING]
  },
  {
    id: '8',
    questionKey: 'faq.gamer.question8',
    descriptionKey: 'faq.gamer.answer8',
    categories: [FAQCategory.ONBOARDING]
  },
  {
    id: '9',
    questionKey: 'faq.gamer.question9',
    descriptionKey: 'faq.gamer.answer9',
    categories: [FAQCategory.IN_GAME]
  },
  {
    id: '10',
    questionKey: 'faq.gamer.question10',
    descriptionKey: 'faq.gamer.answer10',
    categories: [FAQCategory.IN_GAME]
  },
  {
    id: '11',
    questionKey: 'faq.gamer.question11',
    descriptionKey: 'faq.gamer.answer11',
    categories: [FAQCategory.IN_GAME]
  },
  {
    id: '12',
    questionKey: 'faq.gamer.question12',
    descriptionKey: 'faq.gamer.answer12',
    categories: [FAQCategory.IN_GAME]
  },
  {
    id: '13',
    questionKey: 'faq.gamer.question13',
    descriptionKey: 'faq.gamer.answer13',
    categories: [FAQCategory.IN_GAME]
  },
  {
    id: '14',
    questionKey: 'faq.gamer.question14',
    descriptionKey: 'faq.gamer.answer14',
    categories: [FAQCategory.IN_GAME]
  },
  {
    id: '15',
    questionKey: 'faq.gamer.question15',
    descriptionKey: 'faq.gamer.answer15',
    categories: [FAQCategory.IN_GAME]
  },
  {
    id: '16',
    questionKey: 'faq.gamer.question16',
    descriptionKey: 'faq.gamer.answer16',
    categories: [FAQCategory.IN_GAME]
  },
  {
    id: '17',
    questionKey: 'faq.gamer.question17',
    descriptionKey: 'faq.gamer.answer17',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '18',
    questionKey: 'faq.gamer.question18',
    descriptionKey: 'faq.gamer.answer18',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '19',
    questionKey: 'faq.gamer.question19',
    descriptionKey: 'faq.gamer.answer19',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '20',
    questionKey: 'faq.gamer.question20',
    descriptionKey: 'faq.gamer.answer20',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '21',
    questionKey: 'faq.gamer.question21',
    descriptionKey: 'faq.gamer.answer21',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '22',
    questionKey: 'faq.gamer.question22',
    descriptionKey: 'faq.gamer.answer22',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '23',
    questionKey: 'faq.gamer.question23',
    descriptionKey: 'faq.gamer.answer23',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '24',
    questionKey: 'faq.gamer.question24',
    descriptionKey: 'faq.gamer.answer24',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '25',
    questionKey: 'faq.gamer.question25',
    descriptionKey: 'faq.gamer.answer25',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '26',
    questionKey: 'faq.gamer.question26',
    descriptionKey: 'faq.gamer.answer26',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '27',
    questionKey: 'faq.gamer.question27',
    descriptionKey: 'faq.gamer.answer27',
    categories: [FAQCategory.FEEDBACK_DEVELOPMENT]
  },
  {
    id: '28',
    questionKey: 'faq.gamer.question28',
    descriptionKey: 'faq.gamer.answer28',
    categories: [FAQCategory.TROUBLESHOOTING]
  },
  {
    id: '29',
    questionKey: 'faq.gamer.question29',
    descriptionKey: 'faq.gamer.answer29',
    categories: [FAQCategory.TROUBLESHOOTING]
  },
  {
    id: '30',
    questionKey: 'faq.gamer.question30',
    descriptionKey: 'faq.gamer.answer30',
    categories: [FAQCategory.TROUBLESHOOTING]
  },
  {
    id: '31',
    questionKey: 'faq.gamer.question31',
    descriptionKey: 'faq.gamer.answer31',
    categories: [FAQCategory.TROUBLESHOOTING]
  },
  {
    id: '32',
    questionKey: 'faq.gamer.question32',
    descriptionKey: 'faq.gamer.answer32',
    categories: [FAQCategory.DATA_AND_INTEGRITY]
  },
  {
    id: '33',
    questionKey: 'faq.gamer.question33',
    descriptionKey: 'faq.gamer.answer33',
    categories: [FAQCategory.DATA_AND_INTEGRITY]
  },
  {
    id: '34',
    questionKey: 'faq.gamer.question34',
    descriptionKey: 'faq.gamer.answer34',
    categories: [FAQCategory.DATA_AND_INTEGRITY]
  },
  {
    id: '35',
    questionKey: 'faq.gamer.question35',
    descriptionKey: 'faq.gamer.answer35',
    categories: [FAQCategory.TESTING]
  }
]
